/**
 * Mapa centralizado de los componentes de formularios modales.
 *
 * Esta estructura permite al ModalManager renderizar el componente adecuado
 * según el nombre del formulario. Asegúrate de que cada clave coincida con
 * el valor usado en la llamada a showModal('clave').
 *
 * Para añadir un nuevo formulario:
 *  1. Importa el componente correspondiente (usando `lazy`).
 *  2. Añade una entrada con una clave única.
 *  3. Indica el path (si aplica) y un título descriptivo.
 *
 * Ejemplo:
 *   showModal('frmclients', { id: 123 });
 */
import { lazy, useEffect } from 'react';
import { useLocation, matchPath } from "react-router-dom";

// Mapa de componentes modales
const modalComponents = {

};

  


// Títulos adicionales de rutas no modales
const TITLES = {
  "/home": "Inicio",
  "/dashboard": "Dashboard",
  "/users": "Usuarios",
  "/consultas": "Consultas",
  "/login": "Iniciar sesión",
  "/errorpage": "Error",
};

export function usePageTitle() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    let title = "Chronos";

    // 1. Rutas definidas estáticamente
    const matchedTitle = Object.entries(TITLES).find(([pattern]) =>
      matchPath(pattern, path)
    );
    if (matchedTitle) title = matchedTitle[1];

    // 2. Comprobamos si coincide con un modal
    Object.entries(modalComponents).forEach(([_, config]) => {
      if (
        config.path &&
        matchPath({ path: config.path, end: true }, path)
      ) {
        title = config.title || `Formulario - ${config.path}`;
      }
    });

    document.title = title;
  }, [location]);
}

export default modalComponents;
